import { DOCUMENT, LocationStrategy } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Observable, map, take } from 'rxjs';

import { User, UserRole } from '../models/user.model';

import { AuthService } from './auth.service';

/** Path under which the accountant host serves the Composer (see libs/infra nginx.conf). */
export const COMPOSER_BASE_HREF = '/composer/';

export function hasComposerAccess(user: User | null | undefined): boolean {
  return user?.userRole === UserRole.Admin || user?.userRole === UserRole.Supervisor;
}

/**
 * Whether this Composer is served inside the accountant host (under /composer/) instead of
 * standalone on its own host.
 */
export function isComposerMerged(locationStrategy: LocationStrategy): boolean {
  return locationStrategy.getBaseHref() === COMPOSER_BASE_HREF;
}

export const composerAccessGuard: CanActivateFn = (): Observable<boolean> | boolean => {
  const locationStrategy = inject(LocationStrategy);
  const location = inject(DOCUMENT).location;
  const authService = inject(AuthService);

  if (!isComposerMerged(locationStrategy)) {
    return true;
  }

  return authService.user$.pipe(
    take(1),
    map(user => {
      if (!user || hasComposerAccess(user)) {
        return true;
      }

      location.assign('/');

      return false;
    }),
  );
};
